<template>
  <div id="view-container">
    <p class="title text-center mapText">
      <v-row>
        <v-col cols="12">
          <span style="font-size: x-large">
            {{ $t(`message.slideSevenTitle`) }}
          </span>
          <br />
          <br />
          <div style="list-style-position: inside; text-align: center;">
            {{ $t(`message.slideSevenMapInstructions`) }}
          </div>
        </v-col>
      </v-row>
    </p>
    <!-- comment type -->
    <div>
      <v-row justify="center">
        <v-btn-toggle v-model="toggle" rounded>
          <v-btn fab x-large @click="commentType = `home`">
            <v-avatar>
              <img
                src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Housing.png"
                alt="Where you live"
              />
            </v-avatar>
          </v-btn>
          <v-btn fab x-large @click="commentType = `work`">
            <v-avatar>
              <img
                src="https://static.arcgis.com/images/Symbols/PeoplePlaces/Office.png"
                alt="Where you work"
              />
            </v-avatar>
          </v-btn>
          <v-btn fab x-large @click="commentType = `school`">
            <v-avatar>
              <img
                src="https://static.arcgis.com/images/Symbols/PeoplePlaces/School.png"
                alt="Where you go to school"
              />
            </v-avatar>
          </v-btn>
          <v-btn fab x-large @click="commentType = `play`">
            <v-avatar>
              <img
                src="https://static.arcgis.com/images/Symbols/OutdoorRecreation/Park.png"
                alt="Where you play (shopping, recreation, entertainment)"
              />
            </v-avatar>
          </v-btn>
        </v-btn-toggle>
      </v-row>
    </div>
    <p class="title text-center mapText">
      <v-row>
        <v-col
          cols="12"
          style="padding: 0 !important;"
          v-html="$t(`message.slideSevenMapIconLabels`)"
        ></v-col>
      </v-row>
    </p>
    <div id="liveWorkPlayView" ref="map" class="map" />

    <div id="remove-points1" class="esri-widget">
      <button id="resetButton1" type="button">
        Remove all points
      </button>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapActions } from "vuex";

export default {
  name: "MultiPointMap",
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  data() {
    return {
      toggle: undefined,
      commentType: null,
      baseUrl: "https://static.arcgis.com/images/Symbols/",
      urls: {
        home: () => {
          return this.baseUrl + "PeoplePlaces/Housing.png";
        },
        work: () => {
          return this.baseUrl + "PeoplePlaces/Office.png";
        },
        school: () => {
          return this.baseUrl + "PeoplePlaces/School.png";
        },
        play: () => {
          return this.baseUrl + "OutdoorRecreation/Park.png";
        }
      },
      baseMarker: {
        type: "picture-marker",
        url: "",
        width: 30,
        height: 30
      },
      audio: null,
      newSlideNumber: null
    };
  },
  watch: {
    "$i18n.locale": function() {
      if (this.newSlideNumber === 6) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(6);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 6) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
    /* eslint-disable */
    const options = { version: "4.12", css: true }; // explicitly set API version to avoid future breaking changes
    loadModules(["esri/Map", "esri/Graphic", "esri/widgets/Locate", "esri/views/MapView", "esri/widgets/Home", "esri/layers/FeatureLayer"], options)
    .then(([Map, Graphic, Locate, MapView, Home, FeatureLayer]) => {
      const map = new Map({
        basemap: "streets-vector"
      });
      const view = new MapView({
        map: map,
        container: "liveWorkPlayView",
        center: [-106.446, 31.810],
        zoom: 9,
        ui: {
          components: ["attribution"]
        }
      });
      const button = new Home({
        view: view
      });
      const locate = new Locate({
        view: view
      });
      view.ui.add(button, "bottom-left");
      view.ui.add(locate, "bottom-left");
      view.ui.add("remove-points1", "bottom-trailing");
      const reset = () => {
        view.graphics.removeAll();
        this.setCoordinatesWithType([]);
      };
      document.getElementById("resetButton1").onclick = reset;
      view.on("click", event => {
        const coords = view.toMap({ x: event.x, y: event.y });
        const type = this.commentType;
        const point = {
          type: "point",
          longitude: coords.longitude,
          latitude: coords.latitude
        };
        let pointGraphic = new Graphic({
          geometry: point
        });
        if (type) {
          const graphicToRemove = view.graphics._items.find(
            item => item.type == type
          );
          view.graphics.remove(graphicToRemove);
          const url = this.urls[type]();
          let markerSymbol = this.getMarkerSymbol(url);
          pointGraphic.symbol = markerSymbol;
          pointGraphic.type = type;
          view.graphics.add(pointGraphic);
        }
        const coordsWithType = view.graphics._items.map(item => ({
          type: item.type,
          x: item.geometry.x,
          y: item.geometry.y
        }));
        this.setCoordinatesWithType(coordsWithType);
      });
    })
    .catch(err => {
      console.error(err);
    });
  },
  methods: {
    ...mapActions("response", ["setCoordinatesWithType"]),
    getMarkerSymbol(url) {
      return { ...this.baseMarker, url: url };
    }
  }
};
</script>

<style>
.map {
  height: 400px;
}
.mapText {
  margin:0% !important;
}
#resetButton1 {
    padding: 3%;
}
</style>